import styled from 'styled-components';

export const Row = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    & + & {
        margin-top: 16px;
    }
`;
